import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useCart } from "../context/CartContext";

export const ProductCard = ({ product, index = 0 }) => {
  const { add } = useCart();
  return (
    <motion.div
      data-testid={`product-card-${product.slug}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: (index % 4) * 0.06 }}
      className="bg-ink2 border border-bone/5 hover:border-honey/50 p-5 flex flex-col gap-4 relative group transition-colors duration-500"
    >
      <Link to={`/product/${product.slug}`} className="block aspect-[4/5] w-full overflow-hidden bg-ink">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
      </Link>

      <div className="flex items-center gap-2">
        <span className="px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border border-bone/20 text-stone">
          {product.strain_type}
        </span>
        <span className="text-[10px] uppercase tracking-wider text-stone">{product.category}</span>
      </div>

      <div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-honey mb-1">{product.brand}</div>
        <Link to={`/product/${product.slug}`}>
          <h3 className="font-display font-bold text-lg leading-tight hover:text-honey transition-colors">{product.name}</h3>
        </Link>
      </div>

      <div className="flex items-center gap-4 text-xs text-stone">
        <span>THC {product.thc}%</span>
        <span>CBD {product.cbd}%</span>
        <span>{product.weight}</span>
      </div>

      <div className="flex items-center justify-between mt-auto pt-2">
        <span className="font-display font-bold text-xl">${product.price.toFixed(2)}</span>
        <button
          data-testid={`add-to-cart-${product.slug}`}
          onClick={() => add(product)}
          className="flex items-center gap-1 rounded-full bg-honey/10 border border-honey/40 text-honey px-4 py-2 text-xs font-bold uppercase tracking-wider hover:bg-honey hover:text-ink transition-colors"
        >
          <Plus size={14} /> Add
        </button>
      </div>
    </motion.div>
  );
};
